import { graphql, useStaticQuery } from "gatsby";
import React, { Fragment } from "react";
import GravityFormForm from "gatsby-gravityforms-component";
import parse from "html-react-parser";
import Img, { ImgProps } from "components/img/img";
import MapMarker from "assets/map-marker.svg";
import "./contact.scss";

interface Props {
  contactFormId: number;
  contactFormHeadline: string;
  address: {
    address: string;
    contactList: {
      contact?: string;
      label?: string;
    }[];
    addressImage: ImgProps;
  };
  mapImage: ImgProps;
  mapLink: string;
}

const Contact: React.FC<Props> = (props) => {
  const formData = useStaticQuery(
    graphql`
      query ContactFormFields {
        allGfForm {
          edges {
            node {
              ...GravityFormComponent
            }
          }
        }
      }
    `
  );

  const handleSuccess = () => {
    //console.log("success");
  };

  const handleError = (e: any) => {
    //console.log("error", e);
  };

  return (
    <div className="contact">
      <div className="contact__wrapper">
        {/* ADDRESS */}
        <div className="contact-address">
          <div className="contact-address__text">
            <div className="contact-address__address">
              {!!props.address.address && parse(props.address.address)}
            </div>
            <table>
              <tbody>
                {props.address.contactList.map((item, key) => (
                  <Fragment key={key}>
                    <tr>
                      <td>{item.label || " "}</td>
                      <td>
                        {!!item.contact && item.contact.includes("@") ? (
                          <a href={`mailto:${item.contact}`}>{item.contact}</a>
                        ) : (
                          item.contact
                        )}
                      </td>
                    </tr>
                  </Fragment>
                ))}
              </tbody>
            </table>
          </div>
          {!!props.address.addressImage && (
            <div className="contact-address__image">
              <Img {...props.address.addressImage} />
            </div>
          )}
        </div>
        {/* FORM */}
        <div className="contact-form">
          <h3>{props.contactFormHeadline}</h3>
          <GravityFormForm
            id={props.contactFormId}
            formData={formData.allGfForm}
            lambda={process.env.LAMBDA_ENDPOINT}
            uccessCallback={handleSuccess}
            errorCallback={handleError}
          />
        </div>
        {/* MAP IMAGE */}
        <a className="contact-map" href={props.mapLink} target="_blank" rel="norefferer">
          <Img {...props.mapImage} />
          <div className="contact-map__marker">
            <MapMarker />
            <span>Luzern</span>
          </div>
        </a>
      </div>
    </div>
  );
};

export default Contact;

export const query = graphql`
  fragment ContactBlock on WpAcfContactBlock {
    AcfContact {
      contactFormId
      contactFormHeadline
      address {
        address
        contactList {
          contact
          label
        }
        addressImage {
          altText
          localFile {
            childImageSharp {
              gatsbyImageData(width: 600, quality: 90)
            }
          }
        }
      }
      mapImage {
        altText
        localFile {
          childImageSharp {
            gatsbyImageData(width: 1200, quality: 90)
          }
        }
      }
      mapLink
    }
  }
`;
